import { FieldValidator } from "./"

export const validatePcn: FieldValidator = value => {
  const PCN_REGEXP = /^[a-zA-Z0-9]{10}/
  let error = null

  //  this field is not required
  if (!value) return null

  if (!value.match(PCN_REGEXP) || value.length !== 10) {
    error = "The PCN doesn't look right, please check again."
  }

  return error
}
